mutation resendHoppermationDefaultSenderValidation($companyId: ID!) {
  resendHoppermationDefaultSenderValidation(companyId: $companyId)
}
